module.exports = __webpack_public_path__ + "img/bear_skear.1a533230.png";